import { BaseModel } from '../base-model';
export interface IAppointmentProperty {
  Address?: string;
  CityName?: string;
  Id?: number;
  KeyDesc?: string;
  OwnerName?: string;
  PhoneNumber?: string;
  Reference?: string;
  VisitDuration?: number;
  OwnerId?: number;
}
export class AppointmentProperty extends BaseModel<IAppointmentProperty> implements IAppointmentProperty {
  constructor(options?: IAppointmentProperty) {
    super(options);
  }
}